var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-cn"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-bd mg20"},[_c('el-row',[_c('el-col',[_c('clue-form',{attrs:{"model":_vm.model},on:{"submit":_vm.submitForm}})],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-hd"},[_c('h4',[_vm._v("新增线索")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644d7ac7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/clue/create.vue
// module id = 1858
// module chunks = 0